// Serviço de API para gerenciamento de usuários
// Data: 2025-01-20

import apiService from './index';

const UsersService = {
  // Listar todos os usuários da conta
  getUsers: async () => {
    try {
      const response = await apiService.get('/api/users');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      throw error;
    }
  },

  // Criar novo usuário
  createUser: async (userData) => {
    try {
      const response = await apiService.post('/api/users', userData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar usuário:', error);
      throw error;
    }
  },

  // Atualizar usuário
  updateUser: async (userId, userData) => {
    try {
      const response = await apiService.put(`/api/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      throw error;
    }
  },

  // Deletar usuário
  deleteUser: async (userId) => {
    try {
      const response = await apiService.delete(`/api/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar usuário:', error);
      throw error;
    }
  },

  // Gerar senha aleatória
  generatePassword: async () => {
    try {
      const response = await apiService.post('/api/users/generate-password');
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar senha:', error);
      throw error;
    }
  }
};

export default UsersService;
























